<template>
  <v-layout row wrap justify-space-between>
    <v-flex xs6>
      <au-datepicker
        v-model="date"
        :label="label"
        :name="name + '_date'"
        :required="required"
        :max-today="maxToday"
        :api-name="name"
      />
    </v-flex>
    <v-flex xs6>
      <v-text-field
        :name="name + '_time'"
        v-model="time"
        v-validate="required ? 'required' : ''"
        type="time"
        prepend-icon="access_time"
        :data-vv-as="label"
        :error-messages="errors.collect(name)"
      ></v-text-field>
    </v-flex>
  </v-layout>
</template>

<script>
import validationErrorsMixin from "@/mixins/validationErrors.mixin";

export default {
  mixins: [validationErrorsMixin],
  props: {
    name: String,
    value: String,
    label: String,
    required: {
      type: Boolean,
      default: false
    },
    maxToday: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      date: null,
      time: null
    };
  },
  created() {
    this.explode();
  },
  watch: {
    date: function() {
      this.$emit("input", this.implode());
    },
    time: function() {
      this.$emit("input", this.implode());
    },
    value: function() {
      this.explode();
    }
  },
  methods: {
    explode() {
      if (this.value) {
        let moment = this.$moment(this.value);
        this.date = moment.format("YYYY-MM-DD");
        this.time = moment.format("HH:mm");
      }
    },
    implode() {
      if (this.date && this.time) {
        return this.$moment(this.date + " " + this.time).format();
      }

      return null;
    }
  }
};
</script>
